// import React from "react";
// import "../styles/CompanyGrowthFlow.css";

// export default function CompanyGrowthFlow() {
//   const data = [
//     { year: "2021-22", turnover: "₹18 Cr" },
//     { year: "2022-23", turnover: "₹28 Cr" },
//     { year: "2023-24", turnover: "₹53 Cr" },
//     { year: "2024-25", turnover: "₹97 Cr" },
//     { year: "2025-26 (Expected)", turnover: "₹150 Cr" },
//   ];

//   return (
//     <div className="growth-container">

//       <h1 className="growth-title">Company Growth Journey</h1>

//       <p className="growth-subtitle">
//         Established on 21st May 2021
//       </p>

//       <div className="growth-flow">

//         {data.map((item, index) => (
//           <React.Fragment key={index}>

//             <div className="growth-card">
//               <h2 className="growth-year">{item.year}</h2>
//               <p className="growth-turnover">{item.turnover}</p>
//               <p className="growth-label">Annual Turnover</p>
//             </div>

//             {index !== data.length - 1 && (
//               <div className="growth-arrow">→</div>
//             )}

//           </React.Fragment>
//         ))}

//       </div>

//     </div>
//   );
// }





import React from "react";
import "../styles/CompanyGrowthFlow.css";

export default function CompanyGrowthFlow() {
  const data = [
    { year: "2021-22", turnover: "₹18 Cr" },
    { year: "2022-23", turnover: "₹28 Cr" },
    { year: "2023-24", turnover: "₹53 Cr" },
    { year: "2024-25", turnover: "₹97 Cr" },
    { year: "2025-26", turnover: "₹150 Cr" },
  ];

  return (
    <div className="growth-container">

      <h1 className="growth-title">Company Growth Journey</h1>

      {/* <p className="growth-subtitle">
        Established on 21st May 2021
      </p> */}

      <div className="growth-flow">

        {data.map((item, index) => (
          <React.Fragment key={index}>

            <div className="growth-card">
              <h2 className="growth-year">{item.year}</h2>
              <p className="growth-turnover">{item.turnover}</p>
              <p className="growth-label">Annual Turnover</p>
            </div>

            {index !== data.length - 1 && (
              <div className="growth-arrow">→</div>
            )}

          </React.Fragment>
        ))}

      </div>

    </div>
  );
}